import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import usePageMeta from '@/hooks/usePageMeta';
import CalendarHeader from './components/CalendarHeader';
import UpdateHighlights from './components/UpdateHighlights';
import CalendarGrid from './components/CalendarGrid';
import CalTip from './components/CalTip';

export default function Calendar() {
  usePageMeta(
    '追漫日历 - 一周连载更新一览 | 我爱漫画网',
    '我爱漫画网追漫日历，按周展示连载漫画的更新日期与时间，最新话数一目了然，帮你合理安排追更节奏，不错过每一话更新。'
  );

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main>
        <CalendarHeader />
        <UpdateHighlights />
        <CalendarGrid />
        <CalTip />
      </main>
      <Footer />
    </div>
  );
}